import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { GET } from '../../../core/_request'
import { useAuth } from '../../../../auth'
import { fieldMapping } from './fieldMapping'
import { couponTransactionLabels } from './labels'
import DetailSection from './DetailSection'
import { KTCardBody } from '../../../../../../general/helpers'
import { PageTitle } from '../../../../../../general/layout/core'
import { getBreadcrumbs } from '../../../../../routing/Breadcrumbs'
import { useIntl } from 'react-intl'

export default function TransactionDetails() {
  const transactionID = useParams()?.id
  const { auth } = useAuth()
  const [details, setDetails] = useState<any>()
  const [detailsLoader, setDetailsLoader] = useState<boolean>()
  const intl = useIntl()

  useEffect(() => {
    const detailsAPI = `promotions/coupon-transactions/${transactionID}/details`
    setDetailsLoader(true)

    // Fetch coupon transaction details
    GET(detailsAPI, auth?.accessToken ?? '')
      .then((res) => {
        const { data } = res
        setDetails(data?.[0] ?? data)
        setDetailsLoader(false)
      })
      .catch((err) => {
        console.error('Failed to load coupon transaction details:', err)
        setDetailsLoader(false)
      })
    //eslint-disable-next-line
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={getBreadcrumbs(intl, 'viewPromotionTransaction')}>
        Coupon Transaction Details
      </PageTitle>
      <KTCardBody>
        <div className='row'>
          {Object.keys(fieldMapping).map((section: string, index: number) => {
            return (
              <div
                className='col-sm-12 col-xs-12 col-md-6 col-lg-6 mb-10 '
                key={`${index}-section`}
              >
                <DetailSection
                  details={details}
                  title={section}
                  fields={fieldMapping[section]}
                  labels={couponTransactionLabels}
                  detailsLoader={detailsLoader}
                />
              </div>
            )
          })}
        </div>
      </KTCardBody>
    </>
  )
}
